// 리뷰·상세 수집 화면 공용 표시 포맷
export function fmtTime(s) { return s ? new Date(s).toLocaleString() : '-'; }

export function fmtBytes(n) {
  if (n == null) return '-';
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
}

// unit: 초·분 표기 (어드민 { s: '초', m: '분 ' }, 영어 { s: 's', m: 'm ' })
export function elapsed(from, to, unit = { s: '초', m: '분 ' }) {
  if (!from) return '-';
  const ms = (to ? new Date(to) : new Date()) - new Date(from);
  const s = Math.max(0, Math.floor(ms / 1000));
  return s < 60 ? `${s}${unit.s}` : `${Math.floor(s / 60)}${unit.m}${s % 60}${unit.s}`;
}
